function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.01,
    height: 9.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 4.9
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.8,
    width: 25.01,
    height: 22.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.84625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 21.185000000000002
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.57,
    width: 25.01,
    height: 28.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.002000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 46.769999999999996
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.96,
    width: 25.01,
    height: 30.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.002000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 76.065
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.18,
    width: 25.01,
    height: 38.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.778888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 110.48
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 129.78,
    width: 25.01,
    height: 40.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.168333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 150.095
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170.4,
    width: 25.01,
    height: 43.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.572857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 192.375
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214.35,
    width: 25.01,
    height: 48.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.572857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 238.435
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 262.52,
    width: 25.01,
    height: 48.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.12625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 286.79999999999995
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 311.08,
    width: 25.01,
    height: 50.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.002000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 336.375
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 361.66,
    width: 25.01,
    height: 51.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.12625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 387.20500000000004
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 412.75,
    width: 25.01,
    height: 56.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.12625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 440.82
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 468.89,
    width: 25.01,
    height: 56.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5010000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 497.02
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 525.15,
    width: 25.01,
    height: 56.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.12625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 553.4399999999999
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 581.73,
    width: 25.01,
    height: 58.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.168333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 611.1750000000001
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.62,
    width: 25.01,
    height: 59.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.168333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.505,
    y: 670.3100000000001
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 0,
    width: 34.1,
    height: 44.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.06,
    y: 22.125
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.11,
    y: 0,
    width: 35.81,
    height: 44.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.162000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 77.015,
    y: 22.125
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.92,
    y: 0,
    width: 37.61,
    height: 44.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.761
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.725,
    y: 22.125
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.53,
    y: 0,
    width: 39.95,
    height: 44.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.505,
    y: 22.125
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.47,
    y: 0,
    width: 41.32,
    height: 44.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.902857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.13,
    y: 22.125
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.79,
    y: 0,
    width: 42.41,
    height: 44.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.30125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 234.995,
    y: 22.125
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.21,
    y: 0,
    width: 44.87,
    height: 44.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.645,
    y: 22.125
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.08,
    y: 0,
    width: 45.38,
    height: 44.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.321428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.77,
    y: 22.125
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.45,
    y: 0,
    width: 46.39,
    height: 44.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.53125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.645,
    y: 22.125
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.85,
    y: 0,
    width: 46.53,
    height: 44.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.115,
    y: 22.125
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.38,
    y: 0,
    width: 46.6,
    height: 44.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.53125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.68,
    y: 22.125
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.98,
    y: 0,
    width: 50.54,
    height: 44.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.321428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.25,
    y: 22.125
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.52,
    y: 0,
    width: 51.33,
    height: 44.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.0227272727272725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.185,
    y: 22.125
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.86,
    y: 0,
    width: 54.01,
    height: 44.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.865,
    y: 22.125
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.87,
    y: 0,
    width: 58.13,
    height: 44.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.916666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.9350000000001,
    y: 22.125
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 44.25,
    width: 56.41,
    height: 45.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 67.21000000000001
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 90.17,
    width: 56.41,
    height: 48.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.687999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 114.39
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 138.61,
    width: 56.41,
    height: 49.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 163.15
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 187.69,
    width: 56.41,
    height: 49.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.098571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 212.535
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 237.39,
    width: 56.41,
    height: 49.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.23125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 262.315
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 287.24,
    width: 56.41,
    height: 54.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 314.605
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 341.97,
    width: 56.41,
    height: 58.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.058571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 371.415
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 400.86,
    width: 56.41,
    height: 60.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.401666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 431.185
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 461.51,
    width: 56.41,
    height: 71.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.641
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 497.32
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 533.14,
    width: 56.41,
    height: 81.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.128181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 573.96
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.01,
    y: 614.78,
    width: 56.41,
    height: 85.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.641
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.215,
    y: 657.39
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 44.25,
    width: 73.97,
    height: 78.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.328333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.405,
    y: 83.555
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.38,
    y: 44.25,
    width: 77.49,
    height: 78.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.125,
    y: 83.555
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.87,
    y: 44.25,
    width: 80.42,
    height: 78.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.101666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.08,
    y: 83.555
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.3,
    y: 44.25,
    width: 81.45,
    height: 78.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.02500000000003,
    y: 83.555
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.74,
    y: 44.25,
    width: 90.12,
    height: 78.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.8,
    y: 83.555
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.87,
    y: 44.25,
    width: 104.47,
    height: 78.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.105,
    y: 83.555
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.33,
    y: 44.25,
    width: 110.67,
    height: 78.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.6650000000001,
    y: 83.555
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 122.86,
    width: 115.97,
    height: 82.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.784999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.405,
    y: 164.215
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 205.57,
    width: 115.97,
    height: 84.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.405,
    y: 247.64499999999998
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 289.72,
    width: 115.97,
    height: 91.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.4425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.405,
    y: 335.49
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 381.26,
    width: 115.97,
    height: 122.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.405,
    y: 442.61
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 503.96,
    width: 115.97,
    height: 196.04,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.194
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.405,
    y: 601.98
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.38,
    y: 122.86,
    width: 145.64,
    height: 156.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.27333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.2,
    y: 200.94
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.02,
    y: 122.86,
    width: 168.01,
    height: 156.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.196363636363635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.025,
    y: 200.94
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.03,
    y: 122.86,
    width: 188.97,
    height: 156.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.515,
    y: 200.94
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.38,
    y: 279.03,
    width: 192.66,
    height: 208.2,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.71,
    y: 383.13
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.38,
    y: 487.23,
    width: 192.66,
    height: 212.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.71,
    y: 593.615
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.04,
    y: 279.03,
    width: 154.61,
    height: 273.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.087142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.345,
    y: 415.965
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.65,
    y: 279.03,
    width: 155.35,
    height: 273.87,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.3249999999999,
    y: 415.965
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.04,
    y: 552.9,
    width: 309.96,
    height: 147.1,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.419999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.02,
    y: 626.4499999999999
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.cf443b03f3709b63462adb9cf8fec5b4.svg";
export { ForwardRef as ReactComponent };